<template>
  <div class="relative h-[350px] w-[350px] -ml-3 sm:m-auto">
    <div
      class="absolute top-0 left-0 right-0 -mt-4 flex items-center justify-center"
    >
      <c-icon name="LocationOnFilled" size="3rem" />
    </div>
    <div
      id="gameContainer"
      class="h-[350px] w-[350px]"
      @click="spinToWin"
    ></div>
    <audio ref="spinAudio" :src="spinSoundObject" preload="auto" />
  </div>
</template>

<script>
import { Wheel } from "https://cdn.jsdelivr.net/npm/spin-wheel@5.0.2/dist/spin-wheel-esm.js";
import CIcon from "../../../core-ui/src/components/CIcon.vue";
import { mapState } from "pinia";
import { authStore } from "../stores/auth";
import spinSound from "@/assets/spin-sound.wav";

export default {
  name: "SpinWheelGame",
  data() {
    return {
      wheel: null,
      spinned: false,
    };
  },
  props: {
    game: {
      type: Object,
      default: () => ({}),
    },
    gameParticipation: {
      type: Object,
      default: () => ({}),
    },
    promotionsById: {
      type: Object,
      default: () => ({}),
    },
  },
  async mounted() {
    let that = this;

    createjs.Sound.registerSound({ src: spinSound, id: "sound" });

    let portions = this.game.coupons
      .map((c) => {
        return {
          label: c.couponPromotionId
            ? this.promotionsById[c.couponPromotionId]?.name.substring(0, 20)
            : "",
        };
      })
      .concat([
        {
          label: this.$t("no-prize-no-emoji"),
        },
      ]);
    const props = {
      items: portions.length < 7 ? [...portions, ...portions] : portions,
      isInteractive: false,
      borderWidth: 8,
      lineWidth: 6,
      pixelRatio: 2,
      itemBackgroundColors: [
        this.branding.accentColor,
        this.branding.secondaryColor,
      ],
      itemLabelFont: "Brandon Text",
      itemLabelColors: [
        this.$utils.colorIsDark(this.branding.accentColor)
          ? "#FFFFFF"
          : "#000000",
        this.$utils.colorIsDark(this.branding.secondaryColor)
          ? "#FFFFFF"
          : "#000000",
      ],
      onRest: () => {
        that.$emit("spinFinished");
      },
      onCurrentIndexChange: () => {
        createjs.Sound.volume = 0.4;
        createjs.Sound.play("sound");
      },
    };

    const container = document.getElementById("gameContainer");

    that.wheel = new Wheel(container, props);
  },
  methods: {
    spinToWin() {
      if (this.spinned) {
        return;
      }
      this.spinned = true;
      let indexToSpin = this.gameParticipation.couponPromotionId
        ? this.game.coupons.findIndex(
            (c) =>
              c.couponPromotionId === this.gameParticipation.couponPromotionId
          )
        : this.game.coupons.length;
      console.log({ indexToSpin });
      const easingFunc = (t) => {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      };
      this.wheel.spinToItem(indexToSpin, 7000, false, 4, 1, easingFunc);
    },
  },
  computed: {
    ...mapState(authStore, ["branding"]),
    spinSoundObject() {
      return spinSound;
    },
  },
  components: {
    CIcon,
  },
};
</script>

<style scoped></style>
